import type { Services } from "../services/services";
import type { JSX } from "react";
import { bound } from "ecce-react";
import { Controller } from "../util/controller";


export abstract class Prompt<T> extends Controller {
	readonly abstract view: () => JSX.Element;

	#onSubmit: ((result: T) => void) | null = null;

	/**
	 * Called by PromptService.
	 */
	private initPrompt(services: Services, onSubmit: (result: T) => void) {
		this.#onSubmit = onSubmit;

		this["injectServices"](services);
		this["runInit"]();
	}

	@bound()
	submit(result: T): void {
		if(!this.#onSubmit) {
			throw new Error("Prompt was not initialised.");
		}

		this.#onSubmit?.(result);
	}
}
